import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Popper from '@mui/material/Popper';
import PopupState, { bindToggle, bindPopper } from 'material-ui-popup-state';
import Fade from '@mui/material/Fade';
import Paper from '@mui/material/Paper';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/material/Typography": Typography, "@mui/material/Button": Button, "@mui/material/Popper": Popper, "material-ui-popup-state": PopupState, "@mui/material/Fade": Fade, "@mui/material/Paper": Paper } } });
export default ClientProvider;
